import { useNodes } from '@xyflow/react'

export default function NodeInspector() {
  const nodes = useNodes()
  return (
    <div className="max-h-[40vh] overflow-auto text-xs bg-background/80 border border-border rounded px-2 py-1 shadow-sm min-w-[220px]">
      <div className="font-semibold mb-1">Node Inspector</div>
      {nodes.length === 0 ? (
        <div className="text-muted-foreground">No nodes</div>
      ) : (
        <ul className="space-y-1">
          {nodes.map((n) => (
            <li key={n.id}>
              <div className="font-medium">{n.id} <span className="opacity-60">({n.type})</span></div>
              <div className="opacity-80">pos: {Math.round(n.position.x)}×{Math.round(n.position.y)}</div>
              {n.measured && (
                <div className="opacity-80">size: {Math.round(n.measured.width || 0)}×{Math.round(n.measured.height || 0)}</div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
